import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "od_cookie_consent";

export function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch (e) { /* storage unavailable */ }
  }, []);

  const choose = (value) => {
    try { localStorage.setItem(KEY, value); } catch (e) {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[100]"
    >
      <div className="rounded-2xl bg-[#2A2624] text-[#FBF6F1] shadow-2xl p-5 border border-white/10">
        <p className="text-sm leading-relaxed">
          We use a few essential cookies to keep Olivia Does running smoothly, and optional ones to understand how the site is used.
          See our <Link to="/privacy" className="underline underline-offset-2 text-[#E7B8C2]">Privacy Policy</Link>.
        </p>
        <div className="flex gap-3 mt-4">
          <button
            data-testid="cookie-accept"
            onClick={() => choose("accepted")}
            className="flex-1 rounded-full bg-[#C97C8C] hover:bg-[#b96a7b] transition-colors text-white text-sm py-2.5 font-medium"
          >
            Accept
          </button>
          <button
            data-testid="cookie-reject"
            onClick={() => choose("rejected")}
            className="flex-1 rounded-full border border-white/25 hover:bg-white/10 transition-colors text-sm py-2.5"
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  );
}
